export const environment = {
  production: false,
  // @ts-ignore
  apiUrl: window.env?.apiUrl || 'http://10.1.11.105:30808/api'
};
